import { SEND_SHOPIFY_CONFIG } from "./types";
import { DELETE_SHOPIFY_CONFIG } from "./types";

export const sendShopifyConfig = (keys, props) => async dispatch => {
  const userId = props.firebase.auth().currentUser.uid;
  const db = props.firestore;

  try {
   
    db.collection("shopify")
      .doc(userId)
      .set({
        api_key: keys.apiKey,
        group: keys.group ? keys.group : "none",
        shopify_password: keys.shopifyPassword,
        connection: "shopify",
        userId: userId,
        url: keys.shopifyUrl,
        id: "shopify_keys"
      });
      
    dispatch({ type: SEND_SHOPIFY_CONFIG });
  } catch (err) {
    console.log(err);
  }
};

export const deleteShopify = (props) => async dispatch => {
  const userId = props.firebase.auth().currentUser.uid;
  const db = props.firestore;

  try{
    const set = await db.collection("shopify").doc(userId)
    set.delete()

    dispatch({ type: DELETE_SHOPIFY_CONFIG });
  }catch(err) {
    console.log(err)
  }
}
